export default __webpack_public_path__ + "static/media/well.cabd9002.jpg";